import { ISubItem } from '@/components/core/navbar/type';
import { CalendarBlankIcon, ContributorIcon, UsersThreeIcon } from '@/components/icons';

import {
  MembersIcon,
  TeamsIcon,
  ProjectsIcon,
  GantryIcon,
  DealsIcon,
  FounderGuidesIcon,
  DemoDayIcon,
  AnalyticsIcon,
  JobsIcon,
  StarFourIcon,
  PlInfraOsIcon,
  ForumIcon,
  PlaaIcon,
  NetworkIntelligenceDashIcon,
  PlAtsIcon,
} from '../components/icons';
import { MagicSparklesIcon } from '@/components/icons';
import { PL_INFRA_OS_PATH } from '@/services/ai-apps/constants';

export const INVESTOR_DB_LINK: ISubItem = {
  icon: <AnalyticsIcon />,
  href: '/investors',
  title: 'Investor DB',
  description: 'PL internal — investor database for sourcing, outreach and intros',
};

// Temporarily hidden
// export const FOUNDER_DB_LINK: ISubItem = {
//   icon: <AnalyticsIcon />,
//   href: '/founders',
//   title: 'Founder DB',
//   description: 'PL internal — founder sourcing database',
// };

export const DIRECTORY_LINKS: ISubItem[] = [
  {
    icon: <MembersIcon />,
    href: '/members',
    title: 'Members',
    description: 'Connect with individuals across the network',
  },
  {
    icon: <TeamsIcon />,
    href: '/teams',
    title: 'Teams',
    description: 'Discover organizations in web3, AI, neurotech and other innovation areas',
  },
  {
    icon: <ProjectsIcon />,
    href: '/projects',
    title: 'Projects',
    description: 'See what the network is building',
  },
] as const;

export const JOBS_LINK: ISubItem = {
  icon: <JobsIcon />,
  href: '/jobs',
  title: 'Job Board',
  description: 'Open roles across the Protocol Labs network',
};

export const EVENT_LINKS: ISubItem[] = [
  {
    href: '/events/irl',
    icon: <UsersThreeIcon />,
    title: 'IRL Gatherings',
    description: 'Explore major events and attendees by location',
  },
  {
    href: '/events/all',
    icon: <CalendarBlankIcon />,
    title: 'All Events',
    description: 'Browse and register for all upcoming events',
  },
  {
    href: '/events/contributors',
    icon: <ContributorIcon />,
    title: 'Event Contributors',
    description: 'Hosts, speakers, and sponsors',
  },
] as const;

export const FORUM_LINK: ISubItem = {
  icon: <ForumIcon />,
  href: '/forum',
  title: 'Forum',
  description: 'Community discussions across the network',
};

export const DEALS_LINK: ISubItem = {
  icon: <DealsIcon />,
  href: '/deals',
  title: 'Deals',
  description: 'Exclusive tools and perks for founders',
};

export const FOUNDER_GUIDES_LINK: ISubItem = {
  icon: <FounderGuidesIcon />,
  href: '/founder-guides',
  title: 'Founder Guides',
  description: 'Structured, expert-driven guides for startup founders',
};

export const PLAA_LINK: ISubItem = {
  icon: <PlaaIcon />,
  href: '/alignment-asset',
  title: 'PLAA',
  description: 'Collect and track rewards for your contributions across the network',
};

export const GANTRY_LINK: ISubItem = {
  icon: <GantryIcon />,
  href: '/gantry/dashboard',
  title: 'Gantry',
  description: 'Needs and roadmap',
};

export const DEMO_DAY_LINK: ISubItem = {
  icon: <DemoDayIcon />,
  href: '/demoday',
  title: 'Demo Days',
  description: 'Exclusive events where founders pitch to selected investors',
};

export const DEMO_DAY_ANALYTICS_LINK: ISubItem = {
  icon: <AnalyticsIcon />,
  href: '/demo-day-analytics',
  title: 'Demo Day Analytics',
  description: 'Track Demo Day activity across teams, events, and interactions',
};

export const PL_INFRA_OS_LINK: ISubItem = {
  icon: <PlInfraOsIcon />,
  href: PL_INFRA_OS_PATH,
  title: 'PL Infra OS / Factorio',
  description: 'How PL Infra runs — goals, numbers, work, and weekly updates',
};

export const AI_APPS_LINK: ISubItem = {
  icon: <StarFourIcon />,
  href: '/pl-infra/ai-apps',
  title: 'AI Apps',
  description: 'Deploy AI apps to LabOS and explore builds from other PL Infra members',
};

export const AGENT_SESSIONS_LINK: ISubItem = {
  icon: <MagicSparklesIcon width={20} height={20} />,
  href: '/pl-infra/agent-sessions',
  title: 'Agent Sessions',
  description: 'Create and track autonomous coding agent sessions',
};

export const NETWORK_INTELLIGENCE_DASH_LINK: ISubItem = {
  icon: <NetworkIntelligenceDashIcon />,
  href: 'https://intelligence-reports.plnetwork.io/',
  title: 'Network Intelligence Dash',
  description: 'Tracks the core PL network KPIs organized by strategic pillar',
  external: true,
};

export const PL_ATS_PROD_URL = 'https://ats.os.pl.xyz';

// Each environment points at its own ATS (e.g. dev -> https://ats.dev.os.pl.xyz); unset or blank falls back to prod.
export const getPlAtsUrl = (): string => process.env.NEXT_PUBLIC_PL_ATS_URL?.trim() || PL_ATS_PROD_URL;

export const PL_ATS_LINK: ISubItem = {
  icon: <PlAtsIcon />,
  href: getPlAtsUrl(),
  title: 'PL ATS',
  description: 'AI-native sourcing and hiring pipeline for PL Infra',
  external: true,
};
